import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import BackToLink from '../../BackToLink';
import H2 from '../../H2';
import NextLink from '../../NextLink';
import { TP } from '../../../constants/consts';
import H3 from '../../H3';
import { useTranslation } from '../../../src/i18n';
import { colors } from '../../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 45,
    marginBottom: 25,
  },
  name: {
    fontSize: 62,
    color: colors.text,
    lineHeight: '1em',
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
    },
    display: 'block',
  },
  info: {
    fontSize: 30,
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
}));

const EditStubPageHeader = ({ entity, backToLinkProps, backToLinkText, entityInfo, viewModeLinkProps }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <BackToLink href={backToLinkProps.href} as={backToLinkProps.as}>
        {t(backToLinkText)}
      </BackToLink>
      <div className={classes.titleBlock}>
        <div>
          <H2 className={classes.name}>{entity?.name}</H2>
          <H3 className={classes.info}>{entityInfo}</H3>
        </div>
        <NextLink
          startIcon={<RemoveRedEyeIcon style={{ width: 25, height: 18 }} />}
          href={viewModeLinkProps.href}
          as={viewModeLinkProps.as}
        >
          {t(`${TP}.m_VIEWPAGE`)}
        </NextLink>
      </div>
    </>
  );
};

EditStubPageHeader.propTypes = {
  entity: PropTypes.object,
};

export default memo(EditStubPageHeader);
